import useWorkspaceApiCall from 'hooks/useWorkspaceApiCall';
import { getTrainingWithVersionsAndProgress } from 'api/services/lesson-service';
import { IGetTrainingWithVersionsAndProgressRequest } from "api/models/request/IGetTrainingWithVersionsAndProgressRequest";

export const useGetTrainingWithVersionsAndProgress = () => {
  const { callAPI, loading } = useWorkspaceApiCall<IGetTrainingWithVersionsAndProgressRequest, string>(
      getTrainingWithVersionsAndProgress,
      "",
      "getTrainingWithVersionsAndProgress.error"
  );

  return {
    fetchTrainingWithVersionsAndProgress: callAPI,
    fetchTrainingWithVersionsAndProgressPending: loading
  };
};
